import React, { useEffect, useState } from 'react'
import { Box, styled } from '@mui/system'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import { Switch } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { ToastContainer } from 'react-toastify'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { Apis } from 'app/Apis/Apis'
import Alert from '@mui/material/Alert'

const Container = styled('div')(({ theme }) => ({
    margin: '30px',
    [theme.breakpoints.down('sm')]: {
        margin: '16px',
    },
    '& .breadcrumb': {
        marginBottom: '30px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '16px',
        },
    },
}))

const EditLocation = () => {
    const [statusValue, setStatusValue] = useState(false)
    const [locationdata, setLocationdata] = useState()
    const [message, setMessage] = useState()
    const [alldata, setAllData] = useState({
        area: '',
        latitude: '',
        longitude: '',
        gMapsLink: '',
        status: '',
        radiusServed: '',
    })

    const [searchParams] = useSearchParams()
    const locationId = searchParams.get('_id')

    const navigate = useNavigate()

    let config = {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
    }

    const singleLocation = () => {
        axios
            .get(`${Apis.getSingleLocation}/${locationId}`, config)
            .then((res) => {
                setLocationdata(res?.data?.data)
            })
            .catch((err) => {
                console.log('Error in single role', err)
            })
    }

    const setState = () => {
        setAllData({
            area: locationdata?.area,
            latitude: locationdata?.gpsCoordinates?.latitude,
            longitude: locationdata?.gpsCoordinates?.longitude,
            gMapsLink: locationdata?.gMapsLink,
            radiusServed: locationdata?.radius,
            status: locationdata?.status,
        })
    }

    const handleChange = (e) => {
        setAllData({
            ...alldata,
            [e.target.name]: e.target.value,
        })
    }

    useEffect(() => {
        singleLocation()
    }, [])

    useEffect(() => {
        setState()
    }, [locationdata])

    const handleSubmit = () => {
        const formdata = {
            status: statusValue,
            area: alldata.area,
            gMapsLink: alldata.gMapsLink,
            radius: alldata.radiusServed,
            gpsCoordinates: {
                latitude: alldata.latitude,
                longitude: alldata.longitude,
            },
            _id: locationId,
        }

        if (
            !alldata.area ||
            !alldata.latitude ||
            !alldata.longitude ||
            !alldata.gMapsLink ||
            !alldata.radiusServed
        ) {
            if (!alldata.area) {
                setMessage('Area is required !')
            } else {
                if (!alldata.longitude) {
                    setMessage('Longitude is required !')
                } else {
                    if (!alldata.gMapsLink) {
                        setMessage('Google maps link is required !')
                    } else {
                        if (!alldata.radiusServed) {
                            setMessage('Radius served is required !')
                        }
                    }
                }
            }
        } else {
            {
                axios
                    .put(`${Apis.editLocation}`, formdata, config)
                    .then((res) => {
                        setMessage([
                            res?.data?.message ||
                                'Location updated successfully',
                            res?.data?.code,
                        ])
                        setTimeout(() => {
                            navigate('/dashboard/location')
                        }, 2000)
                    })
                    .catch((err) => {
                        console.log(
                            'Error in Edit user',
                            err?.response?.data?.message
                        )
                        setMessage(err?.response?.data?.message)
                    })
            }
        }

        setTimeout(() => {}, 2000)
    }

    return (
        <Container>
            {message ? (
                <Alert
                    severity={message[1] === 200 ? 'success' : 'error'}
                    sx={{ position: 'fixed', width: '80%' }}
                >
                    {message.length === 2 ? message[0] : message}
                </Alert>
            ) : (
                ''
            )}
            <Link to={'/dashboard/location'}>
                <Box sx={{ padding: '15px 0px' }}>
                    <ArrowBackIcon />
                </Box>
            </Link>

            <Box
                sx={{
                    borderBottom: 'solid',
                    borderColor: 'grey.200',
                    marginBottom: 5,
                    fontWeight: 500,
                    fontSize: 20,
                }}
            >
                Edit location
            </Box>
            <Box
                sx={{
                    borderBottom: 'solid',
                    borderColor: 'grey.200',
                    width: '110%',
                }}
            >
                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Area / Zone</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Area / Zone"
                            type="text"
                            value={alldata?.area}
                            name="area"
                            onChange={handleChange}
                            autoComplete="current-password"
                            sx={{ padding: 0, width: '30vh' }}
                        />{' '}
                    </Box>
                </Box>

                <Box sx={{ display: 'flex' }}>
                    <Box sx={{ width: '30%' }}>GPS coordinates</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                paddingBottom: 1,
                            }}
                        >
                            <TextField
                                id="outlined-password-input"
                                label="Latitude"
                                value={alldata?.latitude}
                                type="number"
                                name="latitude"
                                onChange={handleChange}
                                sx={{ paddingBottom: 1, width: '30vh' }}
                                autoComplete="current-password"
                            />

                            <TextField
                                id="outlined-password-input"
                                label="Longitude"
                                type="number"
                                value={alldata?.longitude}
                                name="longitude"
                                onChange={handleChange}
                                sx={{ paddingBottom: 1, width: '30vh' }}
                                autoComplete="current-password"
                            />
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Google maps link</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Google maps link"
                            sx={{ paddingBottom: 1, width: '30vh' }}
                            type="text"
                            value={alldata?.gMapsLink}
                            name="gMapsLink"
                            onChange={handleChange}
                            autoComplete="current-password"
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Radius served (KM)</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Radius served"
                            sx={{ paddingBottom: 1, width: '30vh' }}
                            type="number"
                            value={alldata?.radiusServed}
                            name="radiusServed"
                            onChange={handleChange}
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Activate area</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <Switch
                            checked={alldata.status}
                            value=""
                            onClick={(e) => {
                                setStatusValue(!statusValue)
                                setAllData({
                                    ...alldata,
                                    status: !alldata.status,
                                })
                            }}
                        />
                    </Box>
                </Box>
            </Box>
            <Button
                variant="contained"
                sx={{ marginTop: 3 }}
                onClick={handleSubmit}
            >
                Submit
            </Button>

            <ToastContainer />
        </Container>
    )
}

export default EditLocation
